<template>
    <component
        :is="CellComponent"
        v-model="form"
        v-bind="{
            mode,
            employer,
            matchings,
            isUserEmployee,
            isUserEmployer,

            date,
            time,
        }"
        @input="emit"
    />
</template>

<script>
import { initExpoEmployer, initExpoMatching } from "@/assets/variables/inits";
import CellForm from "./cell/cell-form.vue";
import CellView from "./cell/cell-view.vue";

export default {
    components: {
        CellForm,
        CellView,
    },
    props: {
        mode: { type: String, default: "form" },
        value: { type: Object, default: initExpoMatching }, // form
        employer: { type: Object, default: initExpoEmployer },
        matchings: { type: Array, default: () => [] },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },

        date: { type: String, default: null },
        time: { type: Number, default: 8 },
    },
    data: () => ({
        form: initExpoMatching(),
    }),
    computed: {
        CellComponent() {
            switch (this.mode) {
                case "form":
                case "read": {
                    return "cell-form";
                }
                case "view": {
                    return "cell-view";
                }
            }
        },
    },
    methods: {
        sync() {
            this.form = initExpoMatching(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
